var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      _vm.onSale
        ? _c("wa-tag", {
            attrs: {
              theme: "yellow",
              label: "On Sale!",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.isExpiredPlan && !_vm.isInModalContext
        ? _c("wa-tag", {
            attrs: {
              theme: "gray inverted",
              label: "Your Expired Plan",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.isCurrentPlan && !_vm.isInModalContext
        ? _c("wa-tag", {
            attrs: {
              theme: "blue",
              label: "Current Plan",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.plan.mostPopular && !_vm.isInModalContext
        ? _c("wa-tag", {
            attrs: {
              theme: "yellow",
              label: "Most Popular",
              position: "top",
              size: "size-sm",
            },
          })
        : !_vm.plan.proDownloadEnabled && !_vm.isInModalContext
        ? _c("wa-tag", {
            attrs: {
              theme: "gravy",
              label: "Online Only",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "h1 margin-bottom-2xs" }, [
        _c(
          "span",
          { style: `color: var(--fa-${_vm.planColor});` },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative",
              attrs: { icon: _vm.$v6[_vm.planIconStyle][_vm.icon], size: "lg" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-nowrap" }, [
          _vm._v(_vm._s(_vm.plan.name)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "flex-grow": "1",
            "flex-shrink": "0",
            "flex-basis": "auto",
          },
        },
        [
          _vm.isInModalContext
            ? [
                _c("h3", { staticClass: "sr-only" }, [
                  _vm._v("This Plan Includes…"),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass:
                      "fa-ul size-sm margin-y-0 display-flex flex-column",
                    staticStyle: { gap: "var(--spacing-4xs)" },
                  },
                  [
                    _vm.planHasProPlusIcons
                      ? _c("li", { staticClass: "b" }, [
                          _c(
                            "span",
                            { staticClass: "fa-li" },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.$v6.solid.faCircleSmall,
                                  size: "xs",
                                  "fixed-width": "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(
                            "\n          Includes all Icon Packs\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { class: _vm.featureListItemClass("pro_icon") },
                      [
                        _c(
                          "span",
                          { staticClass: "fa-li" },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faCircleSmall,
                                size: "xs",
                                "fixed-width": "",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v("\n          Access to all Pro"),
                        _vm.planHasProPlusIcons
                          ? [_vm._v(" and Pro+")]
                          : _vm._e(),
                        _vm._v(" Icons\n        "),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { class: _vm.featureListItemClass("custom_icon") },
                      [
                        _c(
                          "span",
                          { staticClass: "fa-li" },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6.solid.faCircleSmall,
                                size: "xs",
                                "fixed-width": "",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.plan.customIcons === -1
                          ? [
                              _c("font-awesome-icon", {
                                attrs: { icon: _vm.$v6.regular.faInfinity },
                              }),
                            ]
                          : [_vm._v(_vm._s(_vm.plan.customIcons))],
                        _vm._v("\n          Custom icons\n        "),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.planHasProDownload
                      ? _c(
                          "li",
                          { class: _vm.featureListItemClass("download") },
                          [
                            _c(
                              "span",
                              { staticClass: "fa-li" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: _vm.$v6.solid.faCircleSmall,
                                    size: "xs",
                                    "fixed-width": "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v("\n          Download Pro"),
                            _vm.planHasProPlusIcons
                              ? [_vm._v(" and Pro+")]
                              : _vm._e(),
                            _vm._v(" icons\n        "),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", { class: _vm.featureListItemClass("service") }, [
                      _c(
                        "span",
                        { staticClass: "fa-li" },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v6.solid.faCircleSmall,
                              size: "xs",
                              "fixed-width": "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v("\n          Extra Services\n        "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.planIsOnlineOnly
                  ? _c("p", { staticClass: "size-sm margin-top-lg" }, [
                      _vm._v(
                        "\n        Online only via Kits on the web — No icon download, npm, or Figma\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            : [
                _c("h3", { staticClass: "sr-only" }, [
                  _vm._v("About This Plan"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "margin-bottom-0" }, [
                  _vm._v(_vm._s(_vm.plan.description)),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.isShowingDiscount
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "row roomy align-middle align-center margin-y-md",
                  },
                  [
                    _vm.currentDollars !== _vm.planPrice
                      ? _c(
                          "div",
                          {
                            staticClass: "strong text-center",
                            staticStyle: {
                              color: "var(--fa-gravy)",
                              "--padding-right": "var(--spacing-xs)",
                              "--padding-left": "var(--spacing-xs)",
                            },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Regular price:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "size-4xl tablet:size-3xl laptop:size-4xl",
                              },
                              [
                                _c("s", [
                                  _vm._v(_vm._s(_vm.planPrice)),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("/year"),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "strong",
                        staticStyle: {
                          "--padding-right": "var(--spacing-xs)",
                          "--padding-left": "var(--spacing-xs)",
                        },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Current price:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "display-flex align-start align-center",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "size-4xl tablet:size-3xl laptop:size-4xl",
                              },
                              [_vm._v(_vm._s(_vm.currentDollars))]
                            ),
                            _vm._v(" "),
                            _vm.currentCents
                              ? _c(
                                  "span",
                                  { staticClass: "size-lg padding-top-2xs" },
                                  [_vm._v("." + _vm._s(_vm.currentCents))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.priceDurationLabel)),
                          _vm.discountDuration === "once"
                            ? _c("span", [
                                _vm._v(
                                  ", then " + _vm._s(_vm.planPrice) + "/year"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-center margin-bottom-lg",
                    staticStyle: { color: "var(--fa-md-gravy)" },
                    attrs: {
                      "aria-label": _vm.priceDurationDescription,
                      "data-balloon-pos": "up",
                      "data-balloon-length": "fit",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "decorative margin-right-2xs",
                      attrs: { icon: _vm.$v6.solid.faCalendarDays, size: "lg" },
                    }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.priceDurationLabel) + "\n      "
                    ),
                  ],
                  1
                ),
              ]
            : _c("div", { staticClass: "text-center" }, [
                _c("p", { staticClass: "size-4xl strong margin-y-4xs" }, [
                  _vm._v("\n        " + _vm._s(_vm.currentDollars)),
                  _vm.currentCents
                    ? _c("span", [_vm._v("." + _vm._s(_vm.currentCents))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-center margin-bottom-xl",
                    staticStyle: { color: "var(--fa-md-gravy)" },
                    attrs: {
                      "aria-label": "Renews each year",
                      "data-balloon-pos": "up",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "decorative margin-right-2xs",
                      attrs: { icon: _vm.$v6.solid.faCalendarDays, size: "lg" },
                    }),
                    _vm._v("\n        Billed Annually\n      "),
                  ],
                  1
                ),
              ]),
          _vm._v(" "),
          _vm.isCurrentPlan && !_vm.isExpiredPlan
            ? _c(
                "span",
                {
                  class: `button flat size-lg block margin-y-0 ${_vm.planColor} inverted`,
                  staticStyle: { "pointer-events": "none" },
                },
                [_vm._v("Your Plan!")]
              )
            : _vm.isDowngrade
            ? _c(
                "span",
                {
                  staticClass: "button flat size-lg block margin-y-0",
                  staticStyle: { opacity: "0", "pointer-events": "none" },
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("\n      Contact Us\n    ")]
              )
            : _c(
                "site-link",
                {
                  class: `button size-lg block margin-bottom-0 ${_vm.planColor}`,
                  attrs: { to: _vm.planLinkArguments(_vm.plan) },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.trackThen($event, _vm.isInModalContext)
                    },
                  },
                },
                [_vm._v("\n      Get " + _vm._s(_vm.plan.name) + "\n    ")]
              ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }